'use strict';

var pxToNumber$1 = require('../../../../../../../../_virtual/pxToNumber.cjs');

/**
 * Give a px string value, convert it to a number.
 */ const pxToNumber = (px)=>{
    const number = parseFloat(px.replace(/px$/, ""));
    return number;
};

pxToNumber$1.__exports.pxToNumber = pxToNumber;

module.exports = pxToNumber$1.__exports;
//# sourceMappingURL=pxToNumber.cjs.map
